import React, { useRef, useState } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import QuotationFooter from "./QuotationFooter";
import QuotationHeader from "./QuotationHeader";
import { toWords } from "number-to-words";

import { data, useLocation } from "react-router-dom";
import moment from "moment";
import html2pdf from "html2pdf.js";

const QuotationInvoice = () => {
  const pdfRef = useRef();
  const { state } = useLocation();

  console.log("state", state);

  const [printMode, setPrintMode] = useState("letterpad"); // 'plain' | 'letterpad'

  const generatePDF = (mode) => {
    setPrintMode(mode);

    setTimeout(() => {
      const element = document.getElementById("content-to-print");
      const opt = {
        margin: 0,
        filename: `quotation-invoice-${mode}.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      };

      html2pdf().from(element).set(opt).save();
    }, 100); // Slight delay to ensure state update
  };

  const showHeaderFooter = printMode === "letterpad";

  let totalPrice = 0;

  const sumOfTotal =
    state?.forms?.reduce((sum, item) => {
      return sum + Number(item?.qty || 0) * Number(item?.price || 0);
    }, 0) || 0;
  return (
    <>
      <section className="invoice_main_section">
        <div id="content-to-print">
          <div
            id="page1"
            style={{
              width: "777px",
              minHeight: "1050px",
              background: "white",
              padding: "0px 20px",
              margin: "5px 0px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              paddingTop: printMode === "plain" ? "25mm" : "0",
              paddingBottom: printMode === "plain" ? "25mm" : "0",
            }}
          >
            <main>
              {showHeaderFooter && (
                <QuotationHeader content={state?.billName} />
              )}
              <div className="quotation_invoice_container">
                <div className="quotation_invoice_address">
                  <h5 className="quotation_name mt-2">
                    <u>Buyer Name & Address:</u>
                  </h5>
                  <h5 className="quotation_name">
                    Mr.{" "}
                    {state?.customerName
                      ? state?.customerName.toUpperCase()
                      : ""}
                  </h5>
                  <p className="quotation_address">
                    <span>{`${state?.doorNo || ""} ,${state?.street || ""} ,${
                      state?.locality || ""
                    } `}</span>
                    <br />
                    <span>{`${state?.city || ""} ,${state?.state || ""} - ${
                      state?.pincode || ""
                    }`}</span>
                  </p>
                  <p className="quotation_address m-0">
                    CUST GST IN :{state?.customerGstIn || ""}{" "}
                  </p>
                </div>
                <div className="quotation_invoice_details">
                  <p className="quotation_invoice_sub_block">
                    <span className="quotation_invoice_left_text">
                      Quotation No:
                    </span>{" "}
                    <span className="quotation_invoice_right_text">
                      {" "}
                      {state?.quotationNo || ""}
                    </span>
                  </p>
                  <p className="quotation_invoice_sub_block">
                    <span className="quotation_invoice_left_text">Date:</span>{" "}
                    <span className="quotation_invoice_right_text">
                      {state?.quotationDate
                        ? moment(state.quotationDate).format("DD-MM-YYYY")
                        : ""}
                    </span>
                  </p>
                  <p className="quotation_invoice_sub_block">
                    <span className="quotation_invoice_left_text">GST IN:</span>{" "}
                    <span className="quotation_invoice_right_text">
                      <b>{state?.billGstIn || ""}</b>
                    </span>
                  </p>
                  <p className="quotation_invoice_sub_block">
                    <span className="quotation_invoice_left_text">
                      Nature of Business:
                    </span>{" "}
                    <span className="quotation_invoice_right_text">
                      {state?.natureOfBusiness || ""}
                    </span>
                  </p>
                  <p className="quotation_invoice_sub_block">
                    <span className="quotation_invoice_left_text">
                      Site Address :
                    </span>{" "}
                    <span className="quotation_invoice_right_text">
                      {state?.siteAddress || ""}
                    </span>
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-12 px-5 pt-3">
                  <p className="quotation_invoice_title mt-5">
                    Dear Sir/ Madam,
                  </p>
                  <p className="quotation_invoice_title mt-3">
                    Kind Attn: Mr. {state?.kindAttn || ""}
                  </p>

                  <p className="quotation_invoice_title mt-3">Sub,</p>

                  <p className="quotation_invoice_para">
                    {" "}
                    <b>
                      <u>Proposal</u>
                    </b>{" "}
                    <span>{state?.proposal || ""}</span>
                  </p>
                  <p className="quotation_invoice_para">
                    {" "}
                    Further to the Discussion & Site Visit (
                    {state?.siteVisitDate
                      ? moment(state?.siteVisitDate).format("DD-MM-YYYY")
                      : ""}
                    ) had with you on the above subject matter,
                  </p>
                  <p className="quotation_invoice_para">
                    {" "}
                    We are pleased to given below our Best & Professional work
                    Proposal for your esteemed{" "}
                    {state?.categoryType == "Others"
                      ? state?.otherCategoryType
                      : state?.categoryType}{" "}
                    Project.
                  </p>
                </div>
              </div>
            </main>

            <footer>
              <div className="row">
                <div className="col-12 mt-3 px-5">
                  <p className="quotation_thanks">Yours Faithfully,</p>
                  <p className="my-5">
                    For.{" "}
                    <b>
                      {state?.billName ? state?.billName.toUpperCase() : ""}
                    </b>
                  </p>
                  <p className="mt-2">
                    <b>Ram Kumar K N</b>
                  </p>
                </div>
              </div>

              {showHeaderFooter && (
                <QuotationFooter content={state?.billName} />
              )}
            </footer>
          </div>

          <div
            id="page2"
            style={{
              width: "777px",
              minHeight: "1050px",
              padding: "0px 20px",
              background: "white",
              margin: "5px 0px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              paddingTop: printMode === "plain" ? "20mm" : "0",
              paddingBottom: printMode === "plain" ? "20mm" : "0",
            }}
          >
            <main>
              {showHeaderFooter && (
                <QuotationHeader content={state?.billName} />
              )}

              <div className="row">
                <div className="col-12 px-5">
                  <p className="quotation_invoice_para">
                    <b>
                      <u> Proposal / Estimate:</u>
                    </b>{" "}
                    <span>{state?.proposal || ""}</span>
                  </p>
                  <table
                    border="1px solid black"
                    style={{ width: "100%" }}
                    className="mt-4"
                  >
                    <thead>
                      <tr>
                        <th className="invoice_table_heading">S.No</th>
                        <th className="invoice_table_heading">Item</th>
                        <th className="invoice_table_heading">Description</th>
                        <th className="invoice_table_heading">QTY</th>
                        <th className="invoice_table_heading">Spl Price(Rs)</th>
                        <th className="invoice_table_heading">Total(Rs)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {state &&
                        state?.forms?.map((data, i) => {
                          totalPrice =
                            Number(data?.qty || 0) * Number(data?.price || 0);
                          return (
                            <>
                              <tr key={i}>
                                <td className="invoice_table_data">{i + 1}</td>
                                <td className="invoice_table_data">
                                  <b> {data?.item || "-"}</b>
                                </td>
                                <td className="invoice_table_data">
                                  {data?.description || "-"}
                                </td>
                                <td className="invoice_table_data">
                                  {data?.qty || "-"}
                                </td>
                                <td className="invoice_table_data">
                                  {data?.price || "-"}
                                </td>
                                <td className="invoice_table_data">
                                  {totalPrice || "-"}
                                </td>
                              </tr>
                            </>
                          );
                        })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td
                          colSpan="5"
                          className="invoice_table_data"
                          style={{ textAlign: "left" }}
                        >
                          Taxable value:{" "}
                          <b> Rupees&nbsp; {toWords(sumOfTotal)} Only</b>
                          (excl. GST)
                        </td>
                        <td className="invoice_table_data">
                          {" "}
                          {sumOfTotal || "-"}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <p className="quotation_invoice_para">
                    <b> Specifications: </b>
                    {state?.specifications || ""}
                  </p>
                  <p className="quotation_invoice_para mt-4">
                    <b>
                      {" "}
                      <u>Payment Terms:</u>
                    </b>
                  </p>

                  {state?.paymentSplits?.map((data, i) => (
                    <p className="quotation_invoice_list" key={i}>
                      {`${data?.amountInSplit || ""} ${
                        data?.description || ""
                      }`}
                    </p>
                  ))}
                </div>
              </div>
              {/* 70 % on advance after signing the agreement or against Purchase
                order */}

              {/* <p className="quotation_invoice_list">
                15 % on against lift Fabrication completion (on KONE
                Confirmation) before Kone Starting Work
              </p>
              <p className="quotation_invoice_list">
                15 % on against lift coordination work (on KONE Confirmation)
              </p> */}
            </main>

            {showHeaderFooter && (
              <footer className="mt-5">
                <QuotationFooter content={state?.billName} />
              </footer>
            )}
          </div>

          <div
            id="page3"
            style={{
              width: "777px",
              minHeight: "1050px",
              padding: "0px 20px",
              background: "white",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              paddingTop: printMode === "plain" ? "25mm" : "0",
              paddingBottom: printMode === "plain" ? "25mm" : "0",
            }}
          >
            <main>
              {showHeaderFooter && (
                <QuotationHeader content={state?.billName} />
              )}
              <div className="row">
                <div className="col-12 px-5 pt-1">
                  <h5 className="quotation_invoice_title">
                    Terms And Conditions
                  </h5>
                  <p
                    className="quotation_invoice_list"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {state?.termsAndConditions || ""}
                  </p>
                </div>
              </div>
            </main>

            <footer>
              <div className="row">
                <div className="col-12 px-5">
                  {" "}
                  <p className="quotation_thanks">Yours Faithfully,</p>
                  <p className="my-5">
                    For.{" "}
                    <b>
                      {state?.billName ? state?.billName.toUpperCase() : ""}
                    </b>
                  </p>
                  <div className="quotation_bottom_block">
                    <p>
                      <b>Ramkumar K N</b>
                    </p>{" "}
                    <p style={{ textAlign: "left", width: "38%" }}>
                      <b>Customer Acceptance</b>
                    </p>
                  </div>
                </div>
              </div>
              {showHeaderFooter && (
                <>
                  <QuotationFooter content={state?.billName} />
                </>
              )}
            </footer>
          </div>
        </div>

        <div className="d-flex justify-content-center my-3 gap-1">
          <button onClick={() => generatePDF("plain")} className="download_btn">
            Without Letter Pad
          </button>
          <button
            onClick={() => generatePDF("letterpad")}
            className="download_btn"
          >
            With Letter Pad
          </button>
        </div>
      </section>
    </>
  );
};

export default QuotationInvoice;
